import { Container, Grid } from "@mui/material";
import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'
import FeaturesCard from "../../Components/FeaturesCards";
import SectionHeading from "../../Components/SectionHeading";

import roadmapimg from "../../images/roadmap.png"
import roadmapBall from "../../images/roadmapBall.png"
import oneMatch from "../../images/oneMatch.png"
import metaverse from "../../images/metaverse.png"
import NumberCards from "../../Components/NumberCards";

const RoadMap = () => {
    useEffect(() =>{
        AOS.init({duration: 2000})
    })
    return(
        <div id="roadmap" className="mt-5 py-5">
            <Container>
                <Grid
                    container
                    justifyContent="flex-start"
                    alignContent="center"
                    className="pt-5"
                >
                    <Grid
                        xs={12}
                        className="align-self-center text-center"
                        data-aos="fade-up"
                    >
                        <SectionHeading
                            subHeading = "Things to look forward to"
                            heading = "THE ROADMAP" 
                            customClass = " mx-auto text-center"
                        />
                        <a 
                            href="https://t.me/MetaSnooker"
                            className="MS---Neon--Button btn mt-4 mb-5 mx-auto"
                            target="_blank"
                            data-aos="zoom-in"
                        >
                            JOIN OUR TELEGRAM
                        </a>
                    </Grid>
                    <Grid
                        container
                        xs={12}
                        justifyContent="center"
                        className="MS---Roadmap-inner position-relative text-center align-self-center"
                        data-aos="fade-up"
                    >
                        <img src={roadmapimg} />
                        <img src={roadmapBall} className="MS---roadmap-img" />
                        <Grid
                            xs={12}
                            md={7}
                            className="MS---bounce_content d-flex justify-content-between align-self-center py-5 mt-5"
                        >
                            <h3 className="text-right mt-5">20%</h3>
                            <div className=" mt-4">
                                <h6 className="text-left">Q4 (2021)</h6>
                                <p className="text-left mb-0">-Proof of concept</p>
                                <p className="text-left mb-0">-Backend platform to push updates and features</p>
                                <p className="text-left mb-0">-Pre-Alpha build</p>
                                <p className="text-left mb-0">-Website</p>
                                <p className="text-left mb-0">-Multiplayer backend functionality</p>
                                <p className="text-left mb-0">-PvP functionality added</p>
                                <p className="text-left mb-0">-Alpha release</p>
                                <p className="text-left mb-0">-Investor pitch</p>
                                <p className="text-left mb-0">-Player lobby</p>
                                <p className="text-left mb-0">-Registration and login</p>
                                <p className="text-left mb-0">-Initial user testing</p>
                                <p className="text-left mb-0">-Contract development</p>
                                <p className="text-left mb-0">-Social accounts launch</p>
                                <p className="text-left mb-0">-Social Media Marketing</p>
                                <p className="text-left mb-0">-Password recovery</p>
                                <p className="text-left mb-0">-Blockchain integration</p>
                                <p className="text-left mb-0">-Blog</p>
                                <p className="text-left mb-0">-Contract web3 and game integration</p>
                                <p className="text-left mb-0">-Website wallet integration</p>
                            </div>
                        </Grid>
                        <Grid
                            xs={12}
                            md={7}
                            className="MS---bounce_content d-flex justify-content-between align-self-center py-5 mt-5"
                        >
                            <h3 className="text-right mt-5">40%</h3>
                            <div className=" mt-4">
                                <h6 className="text-left">Q1</h6>
                                <p className="text-left mb-0">-User dashboard</p>
                                <p className="text-left mb-0">-UI overhaul</p>
                                <p className="text-left mb-0">-UX improvements</p>
                                <p className="text-left mb-0">-Beta release</p>
                                <p className="text-left mb-0">-Public Beta testing</p>
                                <p className="text-left mb-0">-Micro-influencer marketing</p>
                                <p className="text-left mb-0">-Debugging</p>
                                <p className="text-left mb-0">-Scope defined for V2</p>
                                <p className="text-left mb-0">-Tokenomics consolidation</p>
                                <p className="text-left mb-0">-Private sale</p>
                                <p className="text-left mb-0">-DEX listing</p>
                                <p className="text-left mb-0">-Advisory council</p>
                                <p className="text-left mb-0">-Game optimizations</p>
                                <p className="text-left mb-0 dull">-Security probing</p>
                                <p className="text-left mb-0 dull">-Tournament</p>
                                <p className="text-left mb-0 dull">-Security Audit</p>
                                <p className="text-left mb-0 dull">-CEX listing</p>
                            </div>
                        </Grid>
                        <Grid
                            xs={12}
                            md={7}
                            className="MS---bounce_content d-flex justify-content-between align-self-center py-5"
                        >
                            <h3 className="text-right dull">60%</h3>
                            <div>
                                <h6 className="text-left dull">Q2</h6>
                                <p className="text-left mb-0 dull">-Referral program</p>
                                <p className="text-left mb-0 dull">-Chat integration</p>
                                <p className="text-left mb-0 dull">-Sponsor influential online pool players</p>
                                <p className="text-left mb-0 dull">-Influencer marketing</p>
                                <p className="text-left mb-0 dull">-Android build release</p>
                                <p className="text-left mb-0 dull">-iOS build release</p>
                                <p className="text-left mb-0 dull">-Leaderboards</p>
                                <p className="text-left mb-0 dull">&nbsp;&nbsp;&nbsp;-Highest earner</p>
                                <p className="text-left mb-0 dull">&nbsp;&nbsp;&nbsp;-Highest win rate</p>
                                <p className="text-left mb-0 dull">&nbsp;&nbsp;&nbsp;-Most matches won</p>
                            </div>
                        </Grid>
                        <Grid
                            xs={12}
                            md={7}
                            className="MS---bounce_content d-flex justify-content-between align-self-center py-5"
                        >
                            <h3 className="text-right dull">80%</h3>
                            <div>
                                <h6 className="text-left dull">Q3</h6>
                                <p className="text-left mb-0 dull">-Tiered matchmaking</p>
                                <p className="text-left mb-0 dull">-Tournament functionality</p>
                                <p className="text-left mb-0 dull">-Weekly tournaments</p>
                                <p className="text-left mb-0 dull">-NFT collection announcement</p>
                                <p className="text-left mb-0 dull">-NFT presale</p>
                                <p className="text-left mb-0 dull">-Presale fund buy-backs</p>
                                <p className="text-left mb-0 dull">-NFT marketplace</p>
                            </div>
                        </Grid>
                        <Grid
                            xs={12}
                            md={7}
                            className="MS---bounce_content d-flex justify-content-between align-self-center py-5 mb-5"
                        >
                            <h3 className="text-right mb-5 dull">100%</h3>
                            <div>
                                <h6 className="text-left dull">Q4+</h6>
                                <p className="text-left mb-0 dull">-Brands and sponsors onboarding</p>
                                <p className="text-left mb-0 dull">-VR build release</p>
                                <p className="text-left mb-0 dull">-Metaphysical lobbies</p>
                                <p className="text-left mb-0 dull">-Tournament halls</p>
                                <p className="text-left mb-0 dull">-PvP rooms</p>
                                <p className="text-left mb-0 dull">-NFT collection 2.0</p>
                                <p className="text-left mb-0 dull">&nbsp;&nbsp;&nbsp;-Interior decor items</p>
                                <p className="text-left mb-0 dull">&nbsp;&nbsp;&nbsp;-Environment themes</p>
                                <p className="text-left mb-0 dull">&nbsp;&nbsp;&nbsp;-Rooms</p>
                            </div>
                        </Grid>
                        
                    </Grid>
                    
                </Grid>
            </Container>
        </div>
    );
}
export default RoadMap;